import { salesApi,configDataApi ,crmApi} from "@/services";
const user = {
    namespaced: true,
    state: {
        initData:{},
        configInfo:{},
		versionData:[],
		crmInit: {}
    },
    getters: {
        getInitData: (state) =>state.initData,
        getVersionData: (state) =>state.versionData,
		getConfigInfo: (state) =>state.configInfo,
		getCrmInfo: (state) =>state.crmInit,
    },
    mutations: {
        setInitData: (state, Data) => {
            state.initData = Data;
        },
        setVersionData: (state, Data) => {
            state.versionData = Data;
        },
        setConfigInfo: (state, Data) => {
            state.configInfo = Data;
		},
		setCrmInfo: (state, Data) =>{
			state.crmInit = Data;
		}
    },
    actions: {
        getConfigInfo({ commit }, param) {
            return configDataApi.configData( { dicType:0 } ).then(res => {
                if (res && res.msgCode == '100' ) {
                    if (res.responseData) {
                        commit('setConfigInfo', res.responseData);
                        return res;
                    }
                }
            });
        },
        getDataInit({ commit }, param) {
            return salesApi.findConfigurationInfo( param ).then(res => {
                if (res && res.msgCode == '100' ) {
                    if (res.responseData) {
                        let endtime = res.responseData.endFillDate+24*3600*1000;
                        let beginFillDate = res.responseData.beginFillDate;
                        if( res.responseData.completeFlag !=2){
                            if(beginFillDate >  Date.parse(new Date())){
                                res.responseData.completeFlag = 4;//未开始
                            }
                            if(endtime <=  Date.parse(new Date())){
                                res.responseData.completeFlag = 3;//已截至
                            }
                        }
                        commit('setInitData', res.responseData);
                        return res;
                    }
                }
            });
        },
        getVersionInit({ commit }, param) {
            return salesApi.queryVersionList( param ).then(res => {
                if (res && res.msgCode == '100' ) {
                    if (res.responseData) {
                        //console.log(res.responseData)
                        commit('setVersionData', res.responseData);
                        return res;
                    }
                }
            });
		},
		getCrmInfo({ commit }, param){
			return crmApi.getCrmInit( param ).then(res => {
                if (res && res.msgCode == '100' ) {
                    if (res.responseData) {
                        commit('setCrmInfo', res.responseData);
                        return res;
                    }
                }
            });
		}
    }
}

export default user;